export default {
  itemStyle: {
    normal: {
      borderWidth: '0',
      borderColor: '#ffffff'
    }
  },
  lineStyle: {
    normal: {
      width: 1,
      color: '#aaa'
    }
  },
  symbolSize: '4',
  symbol: 'circle',
  smooth: true,
  color: ['#46a1ff', '#4cc9c8', '#63ce7d', '#f1d677', '#e76378', '#9b6ce0', '#5a5fd2', '#47579f'],
  label: {
    normal: {
      textStyle: {
        color: '#ffffff'
      }
    }
  }
};